export const BUILD_ENV = process.env.REACT_APP_USER_BRANCH || 'develop'

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const formatToCurrency = (number) =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(number)

export function checkIfAccountIsAdmin(cognitoUser) {
  return cognitoUser?.signInUserSession?.accessToken?.payload[
    'cognito:groups'
  ]?.includes('__admin')
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8 // eslint-disable-line

    return v.toString(16)
  })
}

export const getMonthlyBudgetById = (id) => {
  switch (id) {
    case 1:
      return '0-500 €'
    case 2:
      return '500-1.000 €'
    case 3:
      return '1.000-1.500 €'
    case 4:
      return '1.500-2.500 €'
    case 5:
      return '2.500-5.000 €'
    case 6:
      return '5.000 € +'
    default:
      return '-'
  }
}

// Liest eine lesbare Meldung aus einem Amplify-/GraphQL-Fehlerobjekt.
// Amplify verpackt GraphQL-Fehler in err.errors[].
export const extractErrorMessage = (err) => {
  if (!err) return 'Unbekannter Fehler'
  if (err.errors && err.errors.length > 0) {
    return err.errors
      .map(
        (e) =>
          `[${e.errorType || e.extensions?.code || 'GraphQL'}] ${e.message}`
      )
      .join(' | ')
  }
  return err.message || JSON.stringify(err)
}

export const fileTimestamp = () =>
  new Date().toISOString().replace(/[:.]/g, '-')

// Lädt ein JSON als Datei herunter (Backup-Konvention wie in move-spaces).
export const downloadJson = ({ data, filename }) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  setTimeout(() => {
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }, 100)
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
